import { Injectable } from '@angular/core';
import '@coturiv/bootstrap-notify';
import * as jQuery from 'jquery';
const $: any = jQuery;

@Injectable({
  providedIn: 'root'
})
export class MessageService {

  constructor() { }

  sendMessage(title: string, content: string, delay: number = 0, tipo: string = 'info') {
    $.notify({
      // options
      title: '<h4>' + title + '</h4>',
      message: content
    }, {
      // settings
      template: '<div data-notify="container" class="col-xs-11 col-sm-4 alert alert-' + tipo + '" role="alert">' +
        '<button type="button" aria-hidden="true" class="close" data-notify="dismiss">×</button>' +
        '<span data-notify="icon"></span> ' +
        '<span data-notify="title">{1}</span> ' +
        '<span data-notify="message">{2}</span>' +
        '<div class="progress" data-notify="progressbar">' +
        '<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>' +
        '</div>' +
        '<a href="{3}" target="{4}" data-notify="url"></a>' +
        '</div>',
      type: 'notification',
      delay: delay > 0 ? delay : 5000,
      z_index: 1051,
      animate: {
        enter: 'animated fadeInRight',
        exit: 'animated fadeOutRight'
      }
    });
  }

  sendErrorMessage() {
    $.notify({
      // options
      title: '<h2>Error</h2>',
      message: 'Se ha producido un error, favor contactar a la mesa de ayuda.'
    }, {
      // settings
      template: '<div data-notify="container" class="col-xs-11 col-sm-4 alert alert-{0}" role="alert">' +
        '<button type="button" aria-hidden="true" class="close" data-notify="dismiss">×</button>' +
        '<span data-notify="icon"></span> ' +
        '<span data-notify="title">{1}</span> ' +
        '<span data-notify="message">{2}</span>' +
        '<div class="progress" data-notify="progressbar">' +
        '<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>' +
        '</div>' +
        '<a href="{3}" target="{4}" data-notify="url"></a>' +
        '</div>',
      type: 'danger',
      z_index: 1051,
      animate: {
        enter: 'animated fadeInRight',
        exit: 'animated fadeOutRight'
      }
    });
  }
}
